import BillonLogoLink from './BillonLogoLink';

export default BillonLogoLink;
